import { setStorage } from '@/utils/storage'
export const state = {
  lang: '',//当前语言
  windowWidth: '',//浏览器窗口宽度
  windowHeight: '', //浏览器高度
  navValue: null,//侧边栏选中值
  navList: '',//侧边栏列表
  tabsList: '',// tabs列表
  tabsValue: '',//tabs选中值
  userInfo: null, //用户信息
  token: null,
  platformList: null,//所属平台
  platformMap: {},
  pageBtnList: {},//当前页面的按钮权限
  homeMenu: null,//首页权限树
  gameList: [],
  gotoFileList: false,//页面内跳转fileList
}
export const mutations = {
  //修改语言
  SET_LANG(state, data) {
    if (data) {
      state.lang = data
      setStorage({
        name: "language",
        content: data,
      });
    }
  },
  //修改浏览器宽度
  SET_WINDOWWIDTH(state, data) {
    if (data) {
      state.windowWidth = data
    }
  },
  //修改浏览器高度
  SET_WINDOWHEIGHT(state, data) {
    if (data) {
      state.windowHeight = data
    }
  },
  //修改侧边栏选中值
  SET_NAVVALUE(state, data) {
    state.navValue = data
  },
  //修改侧边栏列表
  SET_NAVLIST(state, data) {
    state.navList = data
  },
  //修改tabs列表
  SET_TABSLIST(state, data) {
    if (data) {
      state.tabsList = data
      setStorage({
        name: 'selectedTab',
        content: data
      })

    }
  },
  //修改tabs选中值
  SET_TABSVALUE(state, data) {
    if (data) {
      state.tabsValue = data
    }
  },
  //用户信息
  SET_USERINFO(state, data) {
    if (data) {
      state.userInfo = data
    }
  },
  //token
  SET_TOKEN(state, data) {
    state.token = data
  },
  //所属平台
  SET_PLATFORMLIST(state, data) {
    if (data) {
      state.platformList = data
      const map = {};
      data.map((item) => {
        map[item.code] = item
      })
      state.platformMap = map;
    }
  },
  //当前页面的按钮权限
  SET_PAGEBTNLIST(state, data) {
    state.pageBtnList = {}
    if (data && data.length > 0) {
      data.map((item) => {
        state.pageBtnList[item.code] = item.name;
      });
    }
  },
  //首页权限
  SET_HOMEMENU(state, data) {
    state.homeMenu = data
  },
  SET_GAME_LIST(state, data) {
    state.gameList = data;
  },
  SET_GOTOFILELIST(state, data) {
    state.gotoFileList = data
  }
}
